import React, { Component } from 'react'
import AppSettingsSidebarMenu from './sidebarMenu'

class AppSettingsSidebarComponent extends Component {
    render() {
        return (
			<div className="medium-3 cell medium-padding-collapse">
				<AppSettingsSidebarMenu />
			</div>
        )
    }
}

export default AppSettingsSidebarComponent


// WEBPACK FOOTER //
// ./src/application/components/settings/parts/sidebar.js